<template>
<div>
<!--   <v-container color="primary" class="black--text"> -->

<!--     <v-row justify="center" align="center" class="ma-0 pa-0">
      <v-col cols="12" sm="10" md="10" lg="8" xl="8" class="pa-0">
        <div  :class="[isMobile ? 'title' : 'display-1']">КОНТАКТНАЯ ИНФОРМАЦИЯ ТРЦ «ГАГАРИНСКИЙ» НА ЛЕНИНСКОМ ПРОСПЕКТЕ </div>
      </v-col>
    </v-row> -->
    <v-row justify="center" class="ma-0 pa-0">
      <v-col  cols="12" sm="10" md="10" lg="12" xl="12" class="pa-0">
<!--         <div class="display-1 mb-3 ">
          КОНТАКТНАЯ ИНФОРМАЦИЯ ТРЦ «ГАГАРИНСКИЙ» НА ЛЕНИНСКОМ ПРОСПЕКТЕ          
        </div> -->

<v-row justify="start" class="ma-0 pa-0">
    <v-col cols="2">

  </v-col>
  <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="text-left">
  <p>119334, г. Москва, ул. Вавилова, дом 3.</p>  
  <p>метро: Ленинский проспект, станция МЦК: Площадь Гагарина</p>
  <p>Телефон: <Phone :number= "`+7 (495) 234-47-36`" /> </p>
  <p>e-mail: <Email :emailaddr= "`info@trcgagarinsky.ru`" /></p>

  </v-col>
</v-row>
<v-row justify="start" class="ma-0 pa-0">
<!--   <v-col cols="2">

  </v-col> -->
  <v-col cols="12" class="text-left px-0">
    <YandexMapContacts  />
  </v-col>
</v-row>
<v-row justify="start" class="ma-0 pa-0">
  <v-col cols="2">

  </v-col>
  <v-col cols="12" sm="12" md="10" lg="10" xl="10" class="text-left pa-0">
<!--         <div class="title  mb-3 ">
          Контактная информация по вопросам:
        </div> -->

<v-row justify="start" align="start" class="ma-0 pa-0">

  <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-html="descriptionPageContacts.description">
    
  </v-col>
  </v-row>
  </v-col>
</v-row>
<!-- 
<v-row justify="start" class="ma-0 pa-0">
    <v-col cols="2">

  </v-col>
  <v-col cols="8" class="text-left">
    <p>«Гагаринский» – это ТЦ на Ленинском проспекте, одинаково удобно расположенный как от автомобильной развязки, так и от станций метро и МЦК. Сюда просто и комфортно добраться, в каком бы районе города вы не находились. Близость МЦК, остановок общественного транспорта, метро и Третьего транспортного кольца к ТРЦ делает его популярным и доступным для москвичей и гостей столицы.</p>
        <div class="title mb-3">
          Как добраться до ТЦ «Гагаринский»?
        </div>
    <p>С помощью подробной карты проезда вы можете уточнить, как добраться в ТЦ от МЦК, метро или ТТК, удобно спланировать свой маршрут.</p>
        <div class="title mb-3">
          Как с нами связаться?
        </div>
    <p>Время работы ТРЦ «Гагаринский», магазинов, наличие интересующего Вас товара, о мероприятиях для детей и взрослых, проводимых в ТЦ на Вавилова 3, можно узнать, обратившись непосредственно в магазин по номерам телефонов, представленным на этой странице.</p>
        <div class="title mb-3">
          Возможности для бизнеса
        </div>
    <p>Узнать о наличии свободных площадей для аренды в ТРЦ «Гагаринский», разместить рекламную информацию на баннеры или пилоны – мы рады предложить Вам взаимовыгодное и плодотворное сотрудничество!</p>
    <p>Вопросы аренды: <Phone :number= "`+7 (495) 730-07-59`" /> </p>
    <p>Рекламодатели: <Phone :number= "`+7 (495) 730-28-57`" /> </p>
    <p>Размещения информации на сайте: <Email :emailaddr= "`site@trcgagarinsky.ru`" /> </p>
  </v-col>
</v-row> -->

      </v-col>
    </v-row>

  <!-- </v-container> -->
  </div>
</template>

<script>

import YandexMapContacts from '@/components/YandexMapContacts'
import Phone from '@/components/Phone'
import Email from '@/components/Email'

export default {
  name: 'Contacts',
  components: {
    YandexMapContacts,
    Phone,
    Email
  },
  data: () => ({

  }),
        metaInfo: {
          title: 'Контакты -',

        },

  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    descriptionPageContacts: {
      get () {
        return this.$store.state.pages.allPages.find(fd=>fd.slug==='contacts');
      },

    },    
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setIsMobile', val)
      }
    },    
        titleInnert: {
          get () {
            if(DEBUG) console.log('this.$store.state.category :', this.$store.state.app.titleInner);
            return this.$store.state.app.titleInner;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setTitleInner', val)
          }
        }
  },
  mounted () {    
    if(DEBUG) console.log('mounted Contacts')
    let vApp = this
    this.$nextTick(function () {
      vApp.titleInnert = 'КОНТАКТЫ';

      let scrollEl = document.querySelector('#scrollT');
      scrollEl.scrollTo(0,0);

    })
  }

};
</script>

<style scoped>
  .ymap-container {
  height: 400px;
}
</style>